import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

function placeholder(props) {
  const placeHolderClassName = classNames(
    "placeholder",
    {
      [`opacity-${props.opacity}`]: props.opacity,
      [`width-${props.width}`]: props.width,
      [`height-${props.height}`]: props.height
    },
    props.className || ""
  );

  return <span className={placeHolderClassName} />;
}

placeholder.defaultProps = {
  opacity: 50,
  width: 100,
  height: 8
};

placeholder.propTypes = {
  className: PropTypes.string,
  opacity: PropTypes.oneOf([0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]),
  width: PropTypes.oneOf([0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]),
  height: PropTypes.oneOf([6, 8, 12, 14, 16, 24, 32])
};

export default placeholder;
